import { Box, InputBase, styled } from "@mui/material";
import { Button, createShouldForwardPropBlockList } from "@pmag/ui-components";

export const Root = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8),
    },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(6),
    borderBottom: `1px solid ${theme.palette.core.grey._20}`,

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(8),
        borderBottom: "unset",
    },
}));

export interface NavigationButtonProps {
    hidden: boolean;
}

export const NavigationButton = styled(Button, {
    shouldForwardProp: createShouldForwardPropBlockList(["hidden"]),
})<NavigationButtonProps>(({ hidden }) => ({
    display: hidden ? "none" : "flex",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
}));

export const ResetButton = styled(Button)(({ theme }) => ({
    height: "40px",
    [theme.breakpoints.down("md")]: {
        paddingLeft: 0,
    },
}));

export const InputWithButtonsContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginBottom: theme.spacing(6),

    [theme.breakpoints.up("md")]: {
        alignItems: "center",
        flexDirection: "row",
        marginBottom: theme.spacing(8),
    },
}));

export const TextInputContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    [theme.breakpoints.down("md")]: {
        flex: 1,
    },
}));

export const SingleTextInputContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.down("md")]: {
        flex: 1,
    },
}));

export const StyledTextInput = styled(InputBase)(({ theme, disabled }) => ({
    width: "100%",
    height: theme.spacing(10),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.core.grey._40}`,
    marginTop: theme.spacing(2),
    ...(disabled && { backgroundColor: theme.palette.core.grey._20 }),

    "&.Mui-focused": {
        borderColor: theme.palette.blue._50,
    },

    [theme.breakpoints.up("md")]: {
        width: "270px",
    },
}));

export const OrContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(6),
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(4),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    marginTop: theme.spacing(6),
    justifyContent: "space-between",

    [theme.breakpoints.up("md")]: {
        flex: "unset",
        justifyContent: "unset",
        gap: theme.spacing(4),
        marginLeft: theme.spacing(8),
    },
}));

export const StyledButton = styled(Button)(() => ({
    height: "40px",
}));
